import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import reportWebVitals from './reportWebVitals.ts'
import { sendToAnalytics } from './utils/metrics.ts'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

reportWebVitals(sendToAnalytics);